import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {LocationSearchPageComponent} from "./location/location-search-page/location-search-page.component";
import {OutletSearchPageComponent} from "./outlet/outlet-search-page/outlet-search-page.component";
import {TerminalSearchPageComponent} from "./terminal/terminal-search-page/terminal-search-page.component";
import {WebTerminalSearchPageComponent} from "./web-terminal/web-terminal-search-page/web-terminal-search-page.component";
import {ScreenLayoutSearchPageComponent} from "./screen-layout/screen-layout-search-page/screen-layout-search-page.component";
import {FunctionBarSearchPageComponent} from "./function-bar/function-bar-search-page/function-bar-search-page.component";
import {TableLayoutSearchPageComponent} from "./table-layout/table-layout-search-page/table-layout-search-page.component";
import {FrameworkModule} from "../framework/framework.module";
import {TerminalEditPageComponent} from "./terminal/terminal-edit-page/terminal-edit-page.component";
import {PosSharedModule} from "./pos.shared.module";
import {LocationEditPageComponent} from "./location/location-edit-page/location-edit-page.component";
import {PricingSharedModule} from "../pricing/pricing.shared.module";
import {OutletEditPageComponent} from "./outlet/outlet-edit-page/outlet-edit-page.component";
import {SystemSharedModule} from "../system/system.shared.module";
import {EmployeeSharedModule} from "../employee/employee.shared.module";
import {AddressSharedModule} from "../address/address.shared.module";
import {OutletEditSalePeriodsComponent} from "./outlet/outlet-edit-page/outlet-edit-sale-periods/outlet-edit-sale-periods.component";
import {DateTimeSharedModule} from "../datetime/datetime.shared.module";
import {SalePeriodSearchPageComponent} from "./sale-period/sale-period-search-page/sale-period-search-page.component";
import {SalePeriodEditPageComponent} from "./sale-period/sale-period-edit-page/sale-period-edit-page.component";
import {CustomObjectSharedModule} from "../custom-objects/custom-object.shared.module";
import {TableDefinitionSearchPageComponent} from "./table-definition/table-definition-search-page/table-definition-search-page.component";
import {TableDefinitionEditPageComponent} from "./table-definition/table-definition-edit-page/table-definition-edit-page.component";
import {WebTerminalEditPageComponent} from "./web-terminal/web-terminal-edit-page/web-terminal-edit-page.component";
import {SiteSearchPageComponent} from "./site/site-search-page/site-search-page.component";
import {CustomersSharedModule} from "../customers/customers.shared.module";
import {ScreenLayoutEditPageComponent} from "./screen-layout/screen-layout-edit-page/screen-layout-edit-page.component";
import {ScreenLayoutMenuComponent} from "./screen-layout/screen-layout-edit-page/screen-layout-editor/screen-layout-menu/screen-layout-menu.component";
import {ScreenLayoutTouchItemComponent} from "./screen-layout/screen-layout-edit-page/screen-layout-editor/screen-layout-touch-item/screen-layout-touch-item.component";
import {ScreenLayoutButtonComponent} from "./screen-layout/screen-layout-edit-page/screen-layout-editor/screen-layout-button/screen-layout-button.component";
import {ScreenLayoutEditorComponent} from "./screen-layout/screen-layout-edit-page/screen-layout-editor/screen-layout-editor.component";
import {ScreenLayoutItemPropertiesComponent} from "./screen-layout/screen-layout-edit-page/screen-layout-editor/screen-layout-item-properties/screen-layout-item-properties.component";
import {ScreenLayoutMenuBarComponent} from "./screen-layout/screen-layout-edit-page/screen-layout-editor/screen-layout-menu-bar/screen-layout-menu-bar.component";
import {ScreenLayoutMenuPropertiesComponent} from "./screen-layout/screen-layout-edit-page/screen-layout-editor/screen-layout-menu-properties/screen-layout-menu-properties.component";
import {CatalogueSharedModule} from "../catalogue/catalogue.shared.module";
import {ScreenLayoutSubMenuHeaderComponent} from "./screen-layout/screen-layout-edit-page/screen-layout-editor/screen-layout-sub-menu-header/screen-layout-sub-menu-header.component";
import {CourseDefinitionSearchPageComponent} from "./course-definition/course-definition-search-page/course-definition-search-page.component";
import {CourseDefinitionEditPageComponent} from "./course-definition/course-definition-edit-page/course-definition-edit-page.component";
import {ScreenLayoutMenuBarButtonComponent} from "./screen-layout/screen-layout-edit-page/screen-layout-editor/screen-layout-menu-bar-button/screen-layout-menu-bar-button.component";
import {ScreenLayoutTouchItemCommandsComponent} from "./screen-layout/screen-layout-edit-page/screen-layout-editor/screen-layout-touch-item-commands/screen-layout-touch-item-commands.component";
import {OrderProcessingSharedModule} from "../order-processing/order-processing.shared.module";

@NgModule({
    imports: [
        SharedModule,
        PosSharedModule,
        FrameworkModule,
        CustomObjectSharedModule,
        PricingSharedModule,
        SystemSharedModule,
        EmployeeSharedModule,
        AddressSharedModule,
        DateTimeSharedModule,
        CustomersSharedModule,
        CatalogueSharedModule,
        OrderProcessingSharedModule
    ],
    declarations: [
        LocationSearchPageComponent,
        LocationEditPageComponent,
        OutletSearchPageComponent,
        OutletEditPageComponent,
        OutletEditSalePeriodsComponent,
        TerminalSearchPageComponent,
        CourseDefinitionSearchPageComponent,
        CourseDefinitionEditPageComponent,
        WebTerminalSearchPageComponent,
        WebTerminalEditPageComponent,
        ScreenLayoutSearchPageComponent,
        FunctionBarSearchPageComponent,
        TableLayoutSearchPageComponent,
        TerminalEditPageComponent,
        SalePeriodSearchPageComponent,
        SalePeriodEditPageComponent,
        TableDefinitionSearchPageComponent,
        TableDefinitionEditPageComponent,
        SiteSearchPageComponent,
        ScreenLayoutEditPageComponent,
        ScreenLayoutEditorComponent,
        ScreenLayoutMenuComponent,
        ScreenLayoutItemPropertiesComponent,
        ScreenLayoutTouchItemComponent,
        ScreenLayoutTouchItemCommandsComponent,
        ScreenLayoutMenuBarComponent,
        ScreenLayoutMenuBarButtonComponent,
        ScreenLayoutButtonComponent,
        ScreenLayoutMenuPropertiesComponent,
        ScreenLayoutSubMenuHeaderComponent
    ],
    exports: [
        LocationSearchPageComponent,
        LocationEditPageComponent,
        OutletSearchPageComponent,
        OutletEditPageComponent,
        TerminalSearchPageComponent,
        CourseDefinitionSearchPageComponent,
        CourseDefinitionEditPageComponent,
        WebTerminalSearchPageComponent,
        ScreenLayoutSearchPageComponent,
        FunctionBarSearchPageComponent,
        TableLayoutSearchPageComponent,
        TerminalEditPageComponent,
        SalePeriodSearchPageComponent,
        SalePeriodEditPageComponent,
        TableDefinitionSearchPageComponent,
        TableDefinitionEditPageComponent,
        WebTerminalEditPageComponent,
        SiteSearchPageComponent,
        ScreenLayoutEditPageComponent,
        ScreenLayoutEditorComponent,
        ScreenLayoutMenuPropertiesComponent,
        ScreenLayoutMenuComponent,
        ScreenLayoutItemPropertiesComponent,
        ScreenLayoutTouchItemComponent,
        ScreenLayoutTouchItemCommandsComponent,
        ScreenLayoutMenuBarComponent,
        ScreenLayoutMenuBarButtonComponent,
        ScreenLayoutButtonComponent,
        ScreenLayoutSubMenuHeaderComponent
    ]
})

export class PosModule {
}
